
import img1 from '../images/icon/icon1.png'
import img2 from '../images/icon/icon2.png'
import img3 from '../images/icon/icon3.png'
import img4 from '../images/icon/icon4.png'


const dataBox = [

    {
        id: 1,
        img: img1,
        title: 'Easy Connect',
        desc: 'TOY KI의 모바일 연동으로 주위 유저와 쉽게 연결되고 소통합니다'
    },
    {
        id: 2,
        img: img3,
        title: 'High Quality',
        desc: '인공지능을 사용하여 유저 맞춤형 아바타를 생성하고 제공합니다'
    },
    {
        id: 3,
        img: img2,
        title: 'Unique Brand',
        desc: '고유한 아바타로 자신을 브랜딩하고 오프라인에서 홍보하는데 활용합니다'
    },
    {
        id: 4,
        img: img4,
        title: 'Community',
        desc: '주변 사람들과 함께 커뮤니티를 형성하여 문화를 만들고 즐기세요'
    },

]

export default dataBox;